/* eslint-disable function-paren-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/indent */
import React, { useEffect, useState } from 'react';
import HotelApi from '@customTypes/hotel-api';
import HotelCard from '@components/HotelCard';
import { Location } from '@components/Hotels/types';
import { groupBy } from 'lodash';
import AvailabilityWidgetSRP from '@components/AvailabilityWidget/AvailabilityWidgetSRP';
import useSessionStorage from '@hooks/useSessionStorage';
import sessionStorageKeys from '@constants/sessionStorageKeys';
import { isWeekend } from '@helpers/date';
import SRPMarketingModule from '@components/MarketingModule/SRPMarketingModule';

type Props = {
  hotels: HotelApi[];
  selectedLocation: Location | null;
  selectedVibes: string[];
};

export default function Places({ hotels, selectedLocation, selectedVibes }: Props) {
  const [nearByTextIndex, setNearByTextIndex] = useState<number>(-2);
  const [groupedHotels, setGroupedHotels] = useState<any>([]);
  const [filteredHotels, setFilteredHotels] = useState<HotelApi[]>([]);

  const { getItem } = useSessionStorage();
  const smartCalendarDate = getItem(sessionStorageKeys.SMART_CALENDAR_DATE);

  const renderAvailabilityWidget = (index: number) => {
    if (index === 1 && smartCalendarDate && isWeekend(smartCalendarDate)) {
      return <AvailabilityWidgetSRP />;
    }

    return null;
  };

  useEffect(() => {
    const duplicatesRemovedHotels: HotelApi[] = [];
    if (hotels.length > 0) {
      let updateText = true;
      const hotelIds: number[] = [];
      hotels.forEach((hotel: HotelApi, index: number) => {
        if (hotel.isNearBy) {
          if (updateText) {
            setNearByTextIndex(index);
          }
          updateText = false;
        }
        if (hotelIds.indexOf(hotel.id) === -1) {
          duplicatesRemovedHotels.push(hotel);
          hotelIds.push(hotel.id);
        }
      });
    }
    setFilteredHotels(duplicatesRemovedHotels);
    const grouped = groupBy(duplicatesRemovedHotels, (hotel) => hotel.cityName);
    setGroupedHotels(grouped);
  }, [hotels, selectedLocation]);

  return (
    <>
      {(selectedLocation?.type === 'city' || selectedLocation?.type === 'alias') &&
        filteredHotels.map((hotel: HotelApi, index: number) => {
          const cityHeaderText = nearByTextIndex === index ? 'Hotels nearby' : '';
          return (
            <React.Fragment key={hotel.id}>
              {cityHeaderText && (
                <p className="mx-6 text-23 font-rp-pn-semi-bold text-rp-primary-black d:w-full d:max-w-1024 d:text-28 d:mx-0">
                  {cityHeaderText}
                </p>
              )}

              <HotelCard
                key={hotel.id}
                hotel={hotel}
                algoliaSearchPosition={index}
                selectedVibes={selectedVibes}
              />

              {/* Marketing Module */}
              {(index === 1 || (filteredHotels.length === 1 && index === 0)) && (
                <div className="px-6 d:px-0">
                  <SRPMarketingModule />
                </div>
              )}

              {renderAvailabilityWidget(index)}
            </React.Fragment>
          );
        })}

      {groupedHotels &&
        (selectedLocation?.type === 'state' ||
          selectedLocation?.type === 'country' ||
          !selectedLocation) &&
        Object.entries(groupedHotels).map((group: any) =>
          group[1].map((hotel: HotelApi, index: number) => (
            <React.Fragment key={hotel.id}>
              {index === 0 && (
                <p className="mx-6 text-23 font-rp-pn-semi-bold text-rp-primary-black d:w-full d:max-w-1024 d:text-28 d:mx-0">
                  {hotel.state ? `${group[0]}, ${hotel.state}` : `${group[0]}`}
                </p>
              )}

              <HotelCard
                key={hotel.id}
                hotel={hotel}
                algoliaSearchPosition={index}
                selectedVibes={selectedVibes}
              />

              {/* Marketing Module */}
              {(index === 1 || (filteredHotels.length === 1 && index === 0)) && (
                <div className="px-6 d:px-0">
                  <SRPMarketingModule />
                </div>
              )}

              {renderAvailabilityWidget(index)}
            </React.Fragment>
          )),
        )}
    </>
  );
}
